/**
 * Utility function to handle Vite preload errors
 * This function sets up an event listener for 'vite:preloadError' events
 * and refreshes the page when such errors occur
 */
export const setupViteErrorHandler = (): void => {
  window.addEventListener('vite:preloadError', () => {
    window.location.reload()
  })
}
